import React from "react";

import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useTranslation } from "react-i18next";

import { Color } from "../../Form/Button";
import Modal from "../../Generic/Modal";
import useStyles from "./styles";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  onLeaveVideoSurvey: () => void;
  unsavedChanges?: boolean;
}

const LeaveModal = (props: Props) => {
  const { open, setOpen, onLeaveVideoSurvey, unsavedChanges } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const Title = (
    <div className={classes.leaveTitle}>
      <div className={classes.headerIcon}>
        <WarningAmberRoundedIcon className={classes.warningIcon} />
      </div>
      {translate("leaveVideoSurvey")}
    </div>
  );

  const renderWarningMessage = () => {
    if (unsavedChanges) {
      return translate("youHaveUnsavedChangesInTheInventory");
    }

    return translate("theCustomerWillBeForcedToLeaveToo");
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      handleClose={() => setOpen(false)}
      title={Title}
      showActionButtons
      data-cy="corfirmLeaveVideoSurveyModal"
      actionButtonProps={{
        onCancel: () => setOpen(false),
        onSave: () => onLeaveVideoSurvey(),
        customColorSave: Color.WARNING,
        customColorCancel: Color.TEXT_INFO,
        textSave: translate("leave"),
        dataCySave: "modalLeaveVideoSurveyButton",
        dataCyCancel: "modalLeaveVideoSurveyCancel",
      }}
    >
      <section className="w-100">
        <h3 className={classes.title}>{translate("youAreAboutToLeaveVideoSurveyAreYouSure")}</h3>

        <span className={classes.warning}>{renderWarningMessage()}</span>
      </section>
    </Modal>
  );
};

export default LeaveModal;
